import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@/assets/scss/vuetify/index.scss';
import fr from 'vuetify/src/locale/fr';

Vue.use(Vuetify);

// noinspection TypeScriptValidateTypes
export default new Vuetify({
    lang: {
      locales: { fr },
      current: 'fr',
    },
    theme: {
        themes: {
            light: {
                primary: '#00A8C2',
                secondary: '#033138',
                accent: '#007a8d',
                error: '#7E0707',
                warning: '#ff9800',
                info: '#ffc107',
                success: '#69AE3F',
				background: '#e5e5e5',
				background_menu: '#383f47',
				btn_nav: '#00A8C2',
				see: '#222222',
				edit: '#222222',
				delete: '#7E0707',
				download: '#222222',
				document: '#222222',
				title: '#FFFFFF',
				subtitle: '#00A8C2',
				btn_bg_add: '#00A8C2',
				btn_txt_add: '#FFFFFF',
				transparent: 'rgba(0,0,0,0)',
            }
        }
    },
});
